// お申込み状況一覧
import React from 'react';
import ProjectShelf from '../molecules/ProjectShelf';
import Heading from '../molecules/Heading';
import { reception_status } from '../Const';
import { Reception } from '../types/ProjectList';

interface Props {
  receptions?: Reception;
}

const ApplicationStatusList: React.FC<Props> = ({ receptions }) => {
  return (
    <div>
      <p className="p-lead mt-5">手続きを進めたいローンを選択し、必要な手続きを行って下さい。</p>
      {receptions &&
        Object.entries(reception_status).map((status, status_index) => {
          // ステータスに対して表示する案件がある場合表示する、「契約完了」ステータスの案件は表示しない
          if (receptions[status[0]] && status[1] !== reception_status.contract_complete) {
            return (
              <div key={status_index}>
                <Heading label={status[1]} size="m" />
                <div className="acc-content">
                  {Object.values(receptions[status[0]]).map((reception: any, index: number) => {
                    return (
                      <ProjectShelf
                        name={reception.appl_name}
                        r_id={reception.r_id}
                        r_cd={reception.reception_cd}
                        date={reception.application_date}
                        loan_name={reception.loan.loan_name}
                        loan_css={reception.loan.css}
                        relationship={reception.relationship}
                        current={reception.current}
                        status={reception.status}
                        agri_fund_name={reception.agri_fund_name}
                        contract_method={reception.contract_method}
                        contracts={reception.contracts}
                        exists_contract={reception.exists_contract}
                        is_open={false}
                        key={index}
                        show_reception_btn
                      />
                    );
                  })}
                </div>
              </div>
            );
          }
        })}
    </div>
  );
};

export default ApplicationStatusList;
